module.exports = __webpack_public_path__ + "img/login_bak.876473bc.png";